import type { Country, PaymentMethod } from '../core/types/requests'

type PaymentOption = { method: PaymentMethod; label: string; note: string; mollie: string; countries: readonly Country[] }

/**
 * Betaalmethodes — één lijst voor afrekenen en Mijn omgeving.
 * `mollie` = de gateway-id uit de oude WooCommerce-winkel (voor de migratie van orders);
 * Laravel gebruikt de Mollie-methode zonder voorvoegsel. `countries`: waar de methode werkt (Wero alleen NL,
 * Bancontact alleen BE). De server weigert een methode die niet bij het land past.
 *
 * Wero is de opvolger van iDEAL. De sleutel blijft `ideal`, want zo heet de methode bij Mollie en in de
 * oude orders; alleen wat de klant ziet heet Wero. Wijzigt Mollie de methode-id, dan verandert alleen deze regel.
 */
export const paymentOptions: PaymentOption[] = [
  { method: 'ideal', label: 'Wero', note: 'Direct via je eigen bank', mollie: 'mollie_wc_gateway_ideal', countries: ['NL'] },
  { method: 'bancontact', label: 'Bancontact', note: 'Met je Belgische bankkaart of app', mollie: 'mollie_wc_gateway_bancontact', countries: ['BE'] },
  { method: 'klarna', label: 'Klarna', note: 'Achteraf betalen binnen 30 dagen', mollie: 'mollie_wc_gateway_klarnapaylater', countries: ['NL', 'BE'] },
  { method: 'card', label: 'Creditcard', note: 'Visa, Mastercard, Amex', mollie: 'mollie_wc_gateway_creditcard', countries: ['NL', 'BE'] },
]

/** De methodes voor een land, in vaste volgorde: de lokale bankmethode eerst. */
export const paymentOptionsFor = (country: Country) => paymentOptions.filter((p) => p.countries.includes(country))

/** Past de methode niet (meer) bij het land, dan de eerste die wel past. */
export const paymentFor = (method: PaymentMethod, country: Country): PaymentMethod => {
  const options = paymentOptionsFor(country)
  return options.some((p) => p.method === method) ? method : (options[0]?.method ?? method)
}

export const paymentLabel = (m: PaymentMethod) => paymentOptions.find((p) => p.method === m)?.label ?? m
